import { Component, EventEmitter, Input, Output } from '@angular/core';

import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'gtd-form-field-code',
  templateUrl: './code.component.html',
})
export class CodeComponent {
  @Input() isLoading: boolean = false;
  @Input() cssClass: string;
  @Input() placeholder: string;
  @Input() control: UntypedFormControl;
  @Input() errorText: string;
  @Input() label = '';
  @Output() resend: EventEmitter<any> = new EventEmitter();

  resendCode(): void {
    if (!this.isLoading) {
      this.resend.emit();
    }
  }
}
